export type PresetPhoto = { id: string; url: string };

export type PropertyOption = {
  name: string;
  count: number;
  legacyResourceId: string;
  parentLegacyId: string;
  propertyLegacyId: string;
  childrenPropertyIds: string[];
  hasChildren: boolean;
  hasAutogeneratedTitle: boolean;
  photos: PresetPhoto[] | null;
  parentCategory: Category;
};

export type PropertySetting = {
  from: number;
  step: number;
  to: number;
};

export enum PropertyType {
  CollectionProperty = 'CollectionProperty',
  BooleanProperty = 'BooleanProperty',
  RangeProperty = 'RangeProperty',
  PhoneNumberProperty = 'PhoneNumberProperty',
  StringProperty = 'StringProperty',
}

export enum CategoryScopeEnum {
  CREATE_AD = 'CREATE_AD',
  DEFAULT = 'DEFAULT',
}

export enum CategoryOrderEnum {
  POSITION_ASC = 'POSITION_ASC',
  DEFAULT = 'DEFAULT',
}

export type Property = {
  legacyResourceId: string;
  name: string;
  popularOptions: PropertyOption[];
  options: PropertyOption[];
  required: boolean;
  settings: PropertySetting;
  type: PropertyType;
  parentLegacyId: string | null;
  isRequired?: boolean;
  hint?: string;
  measurementUnits?: string;
  filterOpenByDefault?: boolean;
};

export type AdBundle = {
  id: string;
  count: number;
  price: number;
};

export type Category = {
  children: Category[];
  count: number;
  hasAutogeneratedTitle: boolean;
  icon: string;
  id: string;
  description: string;
  isPhotoRequiredOnCreate: boolean;
  isPhotoRequiredOnUpdate: boolean;
  isPriceRequired: boolean;
  name: string;
  azName?: string;
  ruName?: string;
  h1: string;
  parent: Category | null;
  path: string;
  position: number;
  propertyOptions?: PropertyOption[];
  bundles: AdBundle[];
  warningMessage?: string;
  properties?: Property[];
  isFreeLimitExceededForUser: boolean;
  paidAdsBalance?: number;
  primaryProperty?: Property;
};

export type CategoryBaseInfo = {
  id: string;
  name: string;
  h1: string;
  path: string;
  icon: string;
  count: number;
  parent: CategoryBaseInfo | null;
};

export type GetCategoryResponse = {
  category: CategoryBaseInfo;
};

export type GetCategoryIdResponse = {
  category: Pick<Category, 'id'>;
};

export type GetCategoryDetailsResponse = {
  category: Category;
};

export type GetCategoryAdsCountResponse = {
  category: Pick<Category, 'count'>;
};

export type GetCategoriesResponse = {
  categories: Category[];
};

export type CategoryProperties = Pick<Category, 'id' | 'properties'>;

export type GetCategoryPropertiesResponse = {
  category: CategoryProperties;
};

export type GetCategoryEntitiesResponse = {
  categoryEntities: (Category | PropertyOption)[];
};

export type GetRootCategoriesResponse = {
  categories: Category[];
};

export type GetChildPropertyOptionsResponse = {
  property: {
    popularOptions: PropertyOption[];
    options: PropertyOption[];
  };
};

export type GetPropertyOptionResponse = {
  propertyOption: PropertyOption;
};
